import { Component, OnInit, OnDestroy, AfterViewInit, Inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ERP_AFFICHAGES_API, ErpAffichagesApi } from '@erp/affichages';
import { ParametreService } from '../main-parametre/parametre.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { Tva } from './parametre-tva/tva.service';
import { Taxe } from './parametre-taxe/taxe.service';

@Component({
  selector: 'app-taxe-tva',
  templateUrl: './taxe-tva.component.html',
  styleUrls: ['./taxe-tva.component.scss']
})
export class TaxeTvaComponent implements OnInit, OnDestroy, AfterViewInit {
   checkPopup: string = 'taxe';
  activeTab: 'tva' | 'taxe' = 'taxe';
  showAddButton: boolean = true;
  private subscriptions = new Subscription();
  private componentId = Math.random().toString(36).substring(2);

  constructor(
    private parametreService: ParametreService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    @Inject(ERP_AFFICHAGES_API) private api: ErpAffichagesApi
  ) {
  }

ngOnInit(): void {
  this.setupRouteSubscription();
  this.setupModalSubscription();
  this.activeTab = 'taxe';
  this.checkPopup = 'taxe';
  this.router.navigate(['/main/parametre/taxe-tva/taxe']);
}

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private setupRouteSubscription(): void {
    this.subscriptions.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        debounceTime(100)
      ).subscribe(() => {
        const currentUrl = this.router.url;
        this.activeTab = currentUrl.includes('/tva') ? 'tva' : 'taxe';
      })
    );
  }

  private setupModalSubscription(): void {
    this.subscriptions.add(
      this.parametreService.openModal$.pipe(debounceTime(100)).subscribe(({ component, action, subType }) => {
        if (component === 'taxe-tva' && action === 'add') {
          this.openModal('ajouter', undefined, undefined, subType || this.activeTab);
        }
      })
    );
  }

  check(tab: 'tva' | 'taxe'): void {
    this.activeTab = tab;
    this.checkPopup = tab;
    this.router.navigate([`/main/parametre/taxe-tva/${tab}`], { queryParamsHandling: 'preserve' }); 
  }

  openModal(type: 'ajouter' | 'update' | 'etat' = 'ajouter', item?: Tva | Taxe, statut?: boolean, subType?: string): void {
    const target = subType || this.activeTab;
    if (target === 'tva') {
      this.api.openTvaModal(type, item as Tva, statut);
    } else if (target === 'taxe') {
      this.api.openTaxeModal(type, item as Taxe, statut);
    }
  }

  addtax(): void {
    this.parametreService.triggerModal('taxe-tva', 'add', this.activeTab);
  }
}
